// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bodyWrapper {\n  background-color: #fff;\n  padding: 56px 0px;\n  position: relative;\n  border-radius: 40px;\n}\n.bodyWrapper button[class~='ant-switch'] {\n  min-width: 32px;\n  height: 20px;\n  background: #d2dbe9;\n}\n.bodyWrapper button[class~='ant-switch-checked'] {\n  background: #d40000;\n}\n.bodyWrapper .ant-switch-handle {\n  width: 16px;\n  height: 16px;\n}", ""]);
// Exports
module.exports = exports;
